import React, { Component } from 'react';
import Popup from 'components/popups/popup';

class PopupImage extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    content() {
        return <img src={this.props.image} />;
    }
}
PopupImage.defaultProps = {
    popupClassName: 'popup-image-gallery',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

class ImageGallery extends Component {
    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    _onClick(image) {
        PopupImage.initPopup({
            image: image
        });
    }

    render() {
        return (
            <div className={this.props.images.length ? 'image-gallery-wrapper' : 'hidden'}>
                <div className="image-gallery">
                    <div className="image-gallery-scroll">
                        {
                            (()=> {
                                let images = [];
                                for(let i = 0; i < this.props.images.length; i++) {
                                    images.push(<a onClick={()=>{this._onClick(this.props.images[i].full)}} key={`image-gallery-thumb-${i}`} className="thumb" style={{backgroundImage: `url(${this.props.images[i].thumb})`}}></a>);
                                }
                                return images;
                            }
                            )()
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ImageGallery;
